import { AddressInput } from 'lib/types'
import { FetchResult } from '@apollo/client'
import { EnumType, jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'

interface Address {
  city?: string
  country_id?: EnumType
  default_shipping?: boolean
  default_billing?: boolean
  firstname?: string
  lastname?: string
  company?: string
  postcode?: string
  region?: {
    region?: string
    region_id?: number
    region_code?: string
  }
  street?: Array<string | undefined>
  telephone?: string
}

export interface UpdateCustomerAddressMutationObject {
  mutation: {
    updateCustomerAddress: {
      __args: {
        id: number
        input: Address | null
      }
      id: boolean
      customer_id: boolean
      region: {
        region: boolean
        region_id: boolean
        region_code: boolean
      } | boolean
      country_id: boolean
      street: boolean
      telephone: boolean
      postcode: boolean
      city: boolean
      default_shipping: boolean
      default_billing: boolean
    }
  }
}

export const updateCustomerAddressMutationObject: UpdateCustomerAddressMutationObject = {
  mutation: {
    updateCustomerAddress: {
      __args: {
        input: null,
        id: 0
      },
      id: true,
      customer_id: true,
      region: {
        region: true,
        region_id: true,
        region_code: true
      },
      country_id: true,
      street: true,
      telephone: true,
      postcode: true,
      city: true,
      default_shipping: true,
      default_billing: true
    }
  }
}

interface UpdateCustomerAddressMutationInput {
  id: number
  payload?: AddressInput
  setDefaultShipping?: boolean
  setDefaultBilling?: boolean
}

export type UpdateCustomerAddressMutation = (input: UpdateCustomerAddressMutationInput) => Promise<FetchResult<any>>

export const createUpdateCustomerAddressMutation = ({ getMutations }: ServiceDependencies): UpdateCustomerAddressMutation => async ({ id, payload, setDefaultBilling, setDefaultShipping }) => {
  const mutation = getMutations().updateCustomerAddressMutation

  if (payload) {
    const { city, countryCode, isDefaultShipping, isDefaultBilling, firstName, lastName, company, postalCode, region, regionId, regionCode, street, street2, phoneNumber, ...rest } = payload

    const address: Address = {
      city,
      country_id: new EnumType(countryCode),
      default_shipping: isDefaultShipping,
      default_billing: isDefaultBilling,
      firstname: firstName,
      lastname: lastName,
      company,
      postcode: postalCode,
      region: {
        region,
        region_id: regionId,
        region_code: regionCode
      },
      street: [street, street2],
      telephone: phoneNumber,
      ...rest
    }

    mutation.mutation.updateCustomerAddress.__args.input = address
  }

  if (setDefaultBilling !== undefined) {
    mutation.mutation.updateCustomerAddress.__args.input = {
      default_billing: setDefaultBilling
    }
    mutation.mutation.updateCustomerAddress.region = false
    mutation.mutation.updateCustomerAddress.country_id = false
    mutation.mutation.updateCustomerAddress.street = false
    mutation.mutation.updateCustomerAddress.telephone = false
    mutation.mutation.updateCustomerAddress.postcode = false
    mutation.mutation.updateCustomerAddress.city = false
    mutation.mutation.updateCustomerAddress.default_shipping = false
  }

  if (setDefaultShipping !== undefined) {
    mutation.mutation.updateCustomerAddress.__args.input = {
      default_shipping: setDefaultShipping
    }
    mutation.mutation.updateCustomerAddress.region = false
    mutation.mutation.updateCustomerAddress.country_id = false
    mutation.mutation.updateCustomerAddress.street = false
    mutation.mutation.updateCustomerAddress.telephone = false
    mutation.mutation.updateCustomerAddress.postcode = false
    mutation.mutation.updateCustomerAddress.city = false
    mutation.mutation.updateCustomerAddress.default_billing = false
  }

  mutation.mutation.updateCustomerAddress.__args.id = id

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
